export function determineFormat(value: string): string {
  const [beforeColon] = value.split(':'); // Extract the part before ":"
  return beforeColon.length === 1 ? '#:##' : '##:##'; // Return the format based on the length
}
